export const API_ROUTES = {
  CONSULTATIONS: {
    BASE: 'consultations',
    INITIALIZE: 'initialize',
    CONTINUE: 'continue',
    RECOMMENDATIONS_SECONDARY: 'recommendations/secondary',
  },
  FEEDBACK: 'feedback',
  QUESTIONS: 'questions',
} as const;
